<template>
  <div class="card w-full">
    <div
      class="text-sm flex flex-col gap-0.5 bg-white border border-dark-secondary rounded-md p-3 shadow-2xs overflow-hidden dark:bg-background-alt dark:border-dark-border text-text-primary dark:text-text-primary-dark"
    >
      <p class="flex justify-between">
        Rut del Tercero:
        <b>{{ rutFormatter(data.thirdParty?.rut) || "No Aplica" }}</b>
      </p>
      <p class="flex justify-between y">
        Nombre del Tercero: <b>{{ data.thirdParty?.name || "No Aplica" }}</b>
      </p>
      <Divider v-if="data.operationType === 3 || data.operationType === 5" />
      <div
        v-if="
          (data.operationType === 3 || data.operationType === 5) &&
          data.status.description !== 'En Corrección' &&
          data.status.id != 8 &&
          data.status.id != 9
        "
        class="flex justify-between y dark: y-dark items-center"
      >
        País Origen de los <br />Recursos:

        <div style="width: 140px; height: 35px">
          <CustomSelect
            :disabled="disabledInput"
            class="w-[140px] h-[35px]"
            selectClass="items-center mt-2 text-sm !w-[140px] h-[35px]"
            v-model="data.resourcesOrigin.country.id"
            optionLabel="name"
            optionValue="id"
            placeholder="Seleccione"
            :options="countryList"
          />
        </div>
      </div>
      <p
        v-else-if="data.operationType === 3 || data.operationType === 5"
        class="flex justify-between y"
      >
        País Origen de los <br />Recursos:
        <b>{{ data.resourcesOrigin.country.description }}</b>
      </p>
      <div
        v-if="
          (data.operationType === 3 || data.operationType === 5) &&
          data.status.description !== 'En Corrección' &&
          data.status.id != 8 &&
          data.status.id != 9
        "
        class="flex justify-between y items-center mt-3"
      >
        <span class="text-sm flex-1">
          Banco Origen de los <br />
          Recursos:</span
        >
        <div style="width: 140px; height: 35px">
          <CustomInput
            :disabled="disabledInput"
            v-model="data.resourcesOrigin.bankName"
            inputClass="!w-[140px] h-[35px]"
          />
        </div>
      </div>
      <p
        v-else-if="data.operationType === 3 || data.operationType === 5"
        class="flex justify-between y"
      >
        Banco Origen de los <br />
        Recursos: <b>{{ data.resourcesOrigin.bankName }}</b>
      </p>

      <Divider />
      <template v-if="data.operationType === 2">
        <p class="flex justify-between y">
          Banco Destino:
          <b>{{ selectedBankDetails?.description || "Sin Datos" }}</b>
        </p>
        <p class="flex justify-between y">
          Cuenta Destino:
          <b>{{ selectedBankDetails?.accountNumber || "Sin Datos" }}</b>
        </p>
        <p class="flex justify-between y">
          Tipo de Cuenta: <b>{{ selectedBankDetails?.type || "Sin Datos" }}</b>
        </p>
        <Divider />
      </template>
      <template v-if="data.operationType === 4 || data.operationType === 6">
        <p class="flex justify-between y">
          País Destino:
          <b>{{ selectedBankDetails?.countryDestination || "Sin Datos" }}</b>
        </p>
        <p class="flex justify-between y">
          Banco Destino:
          <b>{{ selectedBankDetails.description || "Sin Datos" }}</b>
        </p>

        <p class="flex justify-between y">
          Cuenta Destino:
          <b>{{ selectedBankDetails.accountNumber || "Sin Datos" }}</b>
        </p>
        <p class="flex justify-between y">
          > SWIFT Destino:
          <b>{{ selectedBankDetails.codAba || "Sin Datos" }}</b>
        </p>

        <p class="flex justify-between">
          ABA Destino: <b>{{ selectedBankDetails.codSwift || "Sin Datos" }}</b>
        </p>
        <Divider />
        <p class="flex justify-between">
          Banco Intermediario:
          <b>{{ data.intermediaryBank?.description || "No" }}</b>
        </p>
        <p class="flex justify-between">
          Número de cuenta/IBAN/CLABE:
          <b>{{ data.intermediaryBank?.accountNumber || "No Aplica" }}</b>
        </p>
        <p class="flex justify-between">
          SWIFT Intermediario:
          <b>{{ data.intermediaryBank?.codSwift || "No Aplica" }}</b>
        </p>
        <p class="flex justify-between">
          ABA Intermedioario:
          <b>{{ data.intermediaryBank?.codAba || "No Aplica" }}</b>
        </p>
        <Divider />
      </template>

      <p v-if="data.operationType === 1" class="flex justify-between">
        Glosa de Operación <br />
        (Cliente): <b>{{ data.clientComment || "Sin comentarios" }}</b>
      </p>

      <p class="flex justify-between">
        Usuario: <b>{{ data.client || "Sin Datos" }}</b>
      </p>
      <p class="flex justify-between">
        Analista: <b>{{ data.analistName || "Sin Datos" }}</b>
      </p>
      <p class="flex justify-between">
        Supervisor: <b>{{ data.supervisorName || "Sin Datos" }}</b>
      </p>
    </div>
  </div>
</template>

<script setup>
import { rutFormatter } from "@/utils/rutFormatter";
import { ref } from "vue";

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  banksList: {
    type: Array,
    default: () => [],
  },
  countryList: {
    type: Array,
    default: () => [],
  },
});

const selectedBankDetails = computed(() => {
  return props.data.thirdPartyPayment
    ? props.data.thirdParty?.bankDetails
    : props.data.clientData?.bankDetails;
});

const disabledInput = computed(() => {
  return (
    props.data.status.description === "Validado" ||
    props.data.statusType.description === "Rechazado" ||
    props.data.status.description === "En Corrección"
  );
});
</script>
